import React, {useEffect, useLayoutEffect, useRef} from "react";
import {Box, Typography} from "@mui/material";
import style from "./LandingPage.module.scss";
import {useLocation, useNavigate} from "react-router-dom";

type LandingPageInfo = {
    guardianImage: string;
    guardianName: string;
    guardianMessage: string;
    copyrightInfo?: string;
    className?: string;
};
const LADING_PAGE_CONTENT_DICTIONARY: Record<string, LandingPageInfo> = {
    "archives": {
        guardianImage: "/assets/supper-puppy-mobile.png",
        guardianName: "Super Puppy",
        guardianMessage: "Welcome to the Archives Vault. The Vault is currently under construction. This means that, for now, you cannot access your saved files from the Archives Vault. Any files you have saved will be saved into our databases and directly onto your computer. You can access your saved files directly from your machine in the location you have chosen to saved it in. The default saved file will be a time-stamped text file called interaction-history (time stamped).txt.",
        copyrightInfo: "Concept and Design by Brian R. Tan; Coding by Duc Le; Art by Hien & Ngoc; Guardian Illustration by Ai Nhan",
    },
    "anti-scam-defenders": {
        guardianImage: "/assets/kungfu-bear-mobile.png",
        guardianName: "Kungfu Bear",
        className: `${style.scamEduLadingPage}`,
        guardianMessage: `
                  You are in the "anti-scam defenses" function. This function is currently under construction.
                  When completed, this is where we use Artificial Intelligence to utilize information collected to provide with scam blocking and filtering defenses. 
                  You can also check for known scams that have been recorded in our databases. Please note that AI relies on data and cannot provide with full protection. 
                  You should use our scam checking function if you have specific information like a phone number or email to check for known reported scams. 
                  To protect yourself from any scam, we recommend using our scam identification function as this utilize a logic approach that is robust when the process is followed correctly.`
    },
    "contribution-community": {
        guardianImage: "/assets/poodie-and-panda-mobile.png",
        guardianName: "Poodie and Panda",
        guardianMessage: `Welcome to the "Contribution & Community" area. This area is currently under construction. When completed, this is where you can access links to forums and communities talking about scams and how to protect yourself from scams. 
                  You can also choose to "report a scam" here, or donate to vetted individuals and organizations actively trying to bring the fight to the scammers.`
    },
    "scam-education": {
        guardianImage: "/assets/cyborg-bear-mobile.png",
        guardianName: "Cyborg Bear",
        guardianMessage: `Welcome to the "Scam Education" area. This area is currently under construction. When completed, this is where you can access educational materials and resources about scams and how to protect yourself from scams. 
                  You can also access interactive tutorials that will guide you through the process of identifying scams and protecting yourself from scams.`
    },
}

export const LandingPage = () => {
    const copyRightInfoRef = useRef<any>(null);
    const imageGuardianLadingPageRef = useRef<any>(null);
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;
    const lastSegment = currentPath.split('/').filter(Boolean).pop();
    const [ladingPageInfo, setLadingPageInfo] = React.useState<LandingPageInfo>(LADING_PAGE_CONTENT_DICTIONARY['scam-education']);
    //-----------------------------------------------------------------------------------------------
// Dynamically set CSS variable for navbar height to ensure content is not hidden behind it
    const updateCopyrightHeight = () => {
        const height = copyRightInfoRef.current?.offsetHeight || 0;
        console.log("CopyRightInfo height:", height);
        document.documentElement.style.setProperty(
            "--copyright-message-height",
            `${height}px`
        );
    };

    // Re-measure whenever ladingPageInfo changes (i.e. after navigation renders the copyright element)
    useLayoutEffect(() => {
        updateCopyrightHeight();
    }, [navigate, location, lastSegment, ladingPageInfo]);

    useLayoutEffect(() => {
        updateCopyrightHeight(); // lần đầu

        window.addEventListener("resize", updateCopyrightHeight);

        return () => {
            window.removeEventListener("resize", updateCopyrightHeight);
        };
    }, [lastSegment]);
    // useEffect(() => {
    //     const updateCopyrightHeight = () => {
    //         const height = copyRightInfoRef.current?.offsetHeight || 0;
    //         console.log("CopyRightInfo height:", height);
    //         document.documentElement.style.setProperty(
    //             "--copyright-message-height",
    //             `${height}px`
    //         );
    //     };
    //
    //     updateCopyrightHeight(); // lần đầu
    //
    //     window.addEventListener("resize", updateCopyrightHeight);
    //
    //     return () => {
    //         window.removeEventListener("resize", updateCopyrightHeight);
    //     };
    // }, [navigate, location, lastSegment]);

    useEffect(() => {
            if (lastSegment) {
                const item = LADING_PAGE_CONTENT_DICTIONARY[lastSegment];
                setLadingPageInfo(item);
            }
        },
        [navigate, location, lastSegment])

    //
    useEffect(() => {
        const updateImgHeight = () => {
            const height = imageGuardianLadingPageRef.current?.offsetHeight || 0;
            console.log("CopyRightInfo height:", height);
            document.documentElement.style.setProperty(
                "--image-guardian-ladingpage-height",
                `${height}px`
            );
        };

        updateImgHeight(); // lần đầu

        window.addEventListener("resize", updateImgHeight);

        return () => {
            window.removeEventListener("resize", updateImgHeight);
        };
    }, []);
    //

    return (
        <Box className={`${style.landingPage} ${ladingPageInfo.className ?? ''}`}>
            {/* Guardian Image */}
            <Box className={style.guardianWrapper}>
                <img ref={imageGuardianLadingPageRef} src={ladingPageInfo.guardianImage}
                     alt={ladingPageInfo.guardianName}
                     className={style.guardianImage}/>
                {/*<Image className={style.guardianImage}*/}
                {/*/>*/}
            </Box>

            {/* Guardian Message */}
            <Box className={style.messageWrapper}>
                <Typography variant="body1" className={style.guardianMessage}>
                    {/*<Box className={"MuiMessage"}>*/}
                    {ladingPageInfo.guardianMessage}
                    {/*</Box>*/}
                </Typography>
            </Box>
            {ladingPageInfo.copyrightInfo &&
                <Box className={style.messageWrapper2}>
                    <Box className={"MuiCopyrightInfo"} ref={copyRightInfoRef}>
                        {ladingPageInfo.copyrightInfo}
                    </Box>
                </Box>
            }
        </Box>
    );
};
